// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/entry.client.tsx"
);
import.meta.hot.lastModified = "1709167400217.3508";
}
// REMIX HMR END

/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/docs/en/main/file-conventions/entry.client
 */

import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

let currentTitle = document.title;
function checkTitle() {
  if (currentTitle !== document.title) {
    currentTitle = document.title;
    track(document.title, location.href);
  }
  setTimeout(() => window.requestAnimationFrame(checkTitle), 500);
}
checkTitle();

function track(title: string, href: string) {
  fetch("/track", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      date: new Date().getTime(),
      name: title,
      url: href,
    }),
  });
}

window.addEventListener("load", (e) => {
  track(document.title, location.href);
});
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
